{
    "Profile_Dwellings_SwimmingPool.swimmingPool": "FR: Swimming Pool",
    "Profile_Dwellings_SwimmingPool.swimmingPoolDetails": "FR: Swimming Pool Details",
    "Profile_Dwellings_SwimmingPool.type": "FR: Type",
    "Profile_Dwellings_SwimmingPool.construction": "FR: Construction",
    "Profile_Dwellings_SwimmingPool.condition": "FR: Condition",
    "Profile_Dwellings_SwimmingPool.approvedFence": "FR: Approved Fence"
}
